import { GeneralApiProblem } from './api';
import { DigitalOrderOrganization } from './organizations';
import { FacilityInformation } from './facilities';

export interface DigitalOrdersBase {
  id: string;
  userId: string;
  created: number;
  updated: number;
  organization: DigitalOrderOrganization;
  facility: FacilityInformation;
  products?: {
    productSelection?: Record<string, boolean>;
    integrations?: Record<string, boolean>;
  };
  productDetails?: Record<string, string>;
  summary?: any;
  submitted?: boolean;
  orderStatus?: string;
  orderActionsComplete?: number;
  fulfillmentUser?: string;
  fulfillmentTime?: number;
}

export enum OrderStatus {
  INCOMPLETE = 'Incomplete',
  SUBMITTED = 'Submitted',
  REJECTED = 'Rejected',
  FULFILLED = 'Fulfilled',
}

export type DigitalOrdersSaveResponse = { kind: 'ok'; data: string } | GeneralApiProblem;
export type DigitalOrdersSendResponse = { kind: 'ok' } | GeneralApiProblem;
export type GetAllDigitalOrdersResult =
  | { kind: 'ok'; data: DigitalOrdersBase[] }
  | GeneralApiProblem;
export type RemoveDigitalOrderByIdResult = { kind: 'ok'; data: string } | GeneralApiProblem;
